import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { fetchData } from './redux/dataSlice';
import Main from './pages/main/main';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import CityPage from './pages/cityPage/cityPage';
import ProductPage from './pages/productPage/productPage';

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchData());
  }, [dispatch]);  // The fetchData function is called when the component mounts

  return (
    <Router>
     <Routes>
       <Route path="/" element={<Main />} />
       <Route path="/city/:cityName" element={<CityPage />} />
       <Route path="/product/:productCode" element={<ProductPage />} />
     </Routes>
    </Router>
  );
}

export default App;
